import * as React from 'react'
import { Cart as OriginalCart } from '../../Checkout/Cart'

export class TwoYearCart extends OriginalCart {
  public render() {
    const {
      purchaseOption, taxInformation,
    } = this.props
    const {
      paymentDetails,
      membershipPlan: { name: planName },
    } = purchaseOption

    return (
      <section className="order-summary">
        <h2>Order Summary</h2>
        <div className="cart">
          <h3>
            <span className="plan-name">Pro Plan</span>
            <span className="price">${this.formatPrice(purchaseOption.fullPrice())}</span>
          </h3>

          <section className="benefits">
            <ul>
              {this.benefits()}
            </ul>
          </section>

          <section className="billing-plan">
            <ul>
              <li>
                <span className="description">Billing Plan</span>
                <span className="value"><strong>{paymentDetails.paymentTerm}</strong></span>
              </li>
            </ul>
          </section>

          <section className="price-breakdown">
            <ul>
              {this.priceDetails(`${planName} Plan`, paymentDetails.basePrice)}
              {this.renderAdjustments()}
              {this.priceDetails('Sales Tax', taxInformation.salesTaxAmount ? taxInformation.salesTaxAmount : 0.00)}
            </ul>
          </section>

          <section className="total">
            <ul>
              <li className="price-detail due-today">
                <span className="description">Total Due Today</span>
                <span className="amount"><sup>$</sup>{this.formatPrice(this.totalDueToday())}</span>
              </li>
            </ul>
          </section>
          <section className="tax-notes">
            {this.renderTaxNotes()}
          </section>
        </div>
      </section>
    )
  }

  protected renderTaxNotes() {
    const {
      taxInformation,
    } = this.props

    if (taxInformation.salesTaxAmount) {
      return(
        <>
          <p>
            * Tax exempt? No problem. Proceed to checkout and you can submit your sales tax exemption
            certificate in the Billing section of your account for a sales tax refund.
          </p>
          <a href="https://ignitermedia.zendesk.com/hc/en-us/articles/360042745311-Sales-Tax-Update" target='_blank'>Why am I being charged sales tax?</a>
        </>
      )
    }
  }
}
